import ApiService from "@/services/api.service";
import CrawlerService from "@/services/crawler.service";
import JwtService from "@/services/jwt.service";

const route = 'branches';

const branches = {
    get(_id) {
        return new Promise((resolve, reject) => {
            ApiService.get(route, _id).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    add(_module) {
        return new Promise((resolve, reject) => {
            ApiService.post(route, _module).then(({ data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    download(_data) {
        return new Promise((resolve, reject) => {
            CrawlerService.download(`${route}/${JwtService.getBranchId()}/contracts/download`, "?max_installment=" + _data.max_installment).then(response => {
                resolve({headers: response.headers, data: response.data});
            }, (error) => { 
                reject(error);
            });
        });
    },
    edit(_id, _module) {
        return new Promise((resolve, reject) => {
            ApiService.patch(route, _id, _module).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    rem(_id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(route, _id)
                    .then(({ data }) => {
                        resolve(data);
                    }, (error) => {
                        reject(error);
                    });
        });
    }
};

export default branches;